export const VISIBILITY_STATE = Object.freeze({
  EMPTY: "empty",
  PRIVATE: "private",
  PUBLIC: "public",
  MIXED: "mixed",
});

const createSummary = () => ({
  eligibleCount: 0,
  privateCount: 0,
  publicCount: 0,
  excludedConsignedCount: 0,
  sharedItemCount: 0,
  state: VISIBILITY_STATE.EMPTY,
});

const finalizeSummary = (summary) => {
  const next = {
    ...summary,
    eligibleCount: summary.privateCount + summary.publicCount,
  };
  if (next.eligibleCount === 0) next.state = VISIBILITY_STATE.EMPTY;
  else if (next.publicCount === 0) next.state = VISIBILITY_STATE.PRIVATE;
  else if (next.privateCount === 0) next.state = VISIBILITY_STATE.PUBLIC;
  else next.state = VISIBILITY_STATE.MIXED;
  return next;
};

const isOwnedBy = (item, ownerId) => (
  Boolean(ownerId) && String(item?.owner_id || "") === String(ownerId)
);

export function getOwnerVisibilitySummary(items, ownerId) {
  const summary = createSummary();
  if (!ownerId || !Array.isArray(items)) return summary;

  items.forEach((item) => {
    if (!isOwnedBy(item, ownerId)) return;
    if (item?.delegated_user_id) summary.excludedConsignedCount += 1;
    else if (item?.is_public) summary.publicCount += 1;
    else summary.privateCount += 1;
  });

  return finalizeSummary(summary);
}

export function getGroupVisibilitySummaries(items, ownerId, assignments, groups = []) {
  const summaries = {};
  groups.forEach((group) => {
    summaries[String(group?.id)] = createSummary();
  });
  if (!ownerId || !Array.isArray(items) || !assignments || typeof assignments !== "object") {
    return summaries;
  }

  items.forEach((item) => {
    if (!isOwnedBy(item, ownerId)) return;
    const groupIds = [...new Set(
      (Array.isArray(assignments[String(item?.id)]) ? assignments[String(item.id)] : [])
        .map((groupId) => String(groupId))
        .filter((groupId) => summaries[groupId])
    )];
    const isShared = groupIds.length > 1;

    groupIds.forEach((groupId) => {
      const summary = summaries[groupId];
      if (item?.delegated_user_id) {
        summary.excludedConsignedCount += 1;
      } else {
        if (item?.is_public) summary.publicCount += 1;
        else summary.privateCount += 1;
        if (isShared) summary.sharedItemCount += 1;
      }
    });
  });

  Object.keys(summaries).forEach((groupId) => {
    summaries[groupId] = finalizeSummary(summaries[groupId]);
  });
  return summaries;
}
